jQuery(function ($) {
  const $container = $('.swiper-realisation-g2m');
  if (!$container.length) return;

  const $ul = $container.find('ul.wp-block-post-template');
  if (!$ul.length) return;

  $ul.addClass('swiper-wrapper');
  $ul.children('li').addClass('swiper-slide');

  const $swiperEl = $('<div class="swiper swiper-realisation-inner-g2m">');
  $ul.before($swiperEl);
  $swiperEl.append($ul);

  const $pagination = $container.find('.swiper-realisation-pagination-g2m');

  new Swiper($swiperEl[0], {
    slidesPerView: 1,
    loop: true,
    speed: 800,
    pagination: {
      el: $pagination[0],
      clickable: true,
    },
  });
});
